import type {
  TeaserBaseProps,
  TeaserMediaProps,
  TeaserVignetteProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Content, Media, Title, Vignette } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

interface TeaserLonglifeProps extends Omit<TeaserBaseProps, 'areaType'>, TeaserMediaProps, TeaserVignetteProps {}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-longlife](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-longlife)
 * - Storybook: [TeaserLonglife](https://designsystem.dn.se/?path=/docs/section-teaserlonglife--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-longlife/teaser-longlife.scss'`
 */
export const TeaserLonglife = (props: TeaserLonglifeProps) => {
  const { title, targetLink, vignette, media, attributes, classNames } = props
  const classes = formatClassString(['ds-teaser--longlife', classNames])

  return (
    <TeaserCard areaType='right' targetLink={targetLink} classNames={classes} attributes={attributes}>
      <Media media={media} />
      <Content>
        <Vignette vignette={vignette} />
        <Title title={title} />
      </Content>
    </TeaserCard>
  )
}
